/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Auto_ScrollInputs */

const en_read_along_auto_scroll = /** @type {(inputs: Read_Along_Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto scroll`)
};

const es_read_along_auto_scroll = /** @type {(inputs: Read_Along_Auto_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento automático`)
};

/**
* | output |
* | --- |
* | "Auto scroll" |
*
* @param {Read_Along_Auto_ScrollInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_auto_scroll = /** @type {((inputs?: Read_Along_Auto_ScrollInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Auto_ScrollInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_auto_scroll(inputs)
	return en_read_along_auto_scroll(inputs)
});